import type { ApplicationStatus } from "../api";
import { applicationStatusLabel } from "../presentation";

interface ApplicationStatusBadgeProps {
  readonly status: ApplicationStatus;
}

export function ApplicationStatusBadge({ status }: ApplicationStatusBadgeProps) {
  return (
    <span className={`status-badge status-${status}`}>
      <span aria-hidden="true" />
      {applicationStatusLabel(status)}
    </span>
  );
}
